// The only list of live guided-cleanse intakes — same discipline as
// app/dayclinic/clinicDates.ts. It is read by the server page (metadata +
// JSON-LD) and by the client page (nav, hero, dates, pricing, closing CTA), so
// the whole page agrees about whether a live intake is on sale.
//
// Plain (non-"use client") module deliberately: a server component importing
// shared data re-exported through a client module throws at build.
//
// When the list runs dry the page does NOT go blank — it drops every live-only
// claim, leads with the self-paced cleanse and points anyone wanting the live
// version at /contactus. Add new intakes here and the live copy comes back on
// its own.

export type GuidedIntake = {
  /** Also the add_to_cart label suffix — don't reword an intake that has sold. */
  title: string;
  /** Human-readable range shown on the card, and part of the cart line id. */
  range: string;
  /** Availability badge text. */
  status: string;
  /** YYYY-MM-DD. The only thing that decides whether an intake is upcoming. */
  startDate: string;
};

export const GUIDED_INTAKES: GuidedIntake[] = [
  { title: "Guided Cleanse - Intake 2", range: "May 18 – May 24", status: "Open", startDate: "2026-05-18" },
  { title: "Guided Cleanse - Intake 3", range: "Jun 8 – Jun 14", status: "Open", startDate: "2026-06-08" },
  { title: "Guided Cleanse - Intake 4", range: "Jul 6 – Jul 12", status: "Open", startDate: "2026-07-06" },
];

/**
 * Intakes that have not started yet. Compared as UTC ISO dates so the server
 * render and the client hydration reach the same answer.
 */
export function upcomingGuidedIntakes(now: Date = new Date()): GuidedIntake[] {
  const today = now.toISOString().slice(0, 10);
  return GUIDED_INTAKES.filter((intake) => intake.startDate > today);
}

/** One price for both formats. Referenced by the cards, the cart and pricing. */
export const CLEANSE_PRICE = 260;
